/**
 * 图片懒加载指令
 * 使用 Intersection Observer API 实现
 * 使用方法: <img v-lazy="imageSrc" /> 或 <img v-lazy="{ src: imageSrc, placeholder: '...' }" />
 */
export default {
  inserted(el, binding) {
    loadImage(el, binding.value);
  },
  
  update(el, binding) {
    // 如果图片地址发生变化，重新加载
    const currentSrc = el.getAttribute('data-lazy-src') || el.src;
    const newSrc = typeof binding.value === 'string' ? binding.value : binding.value?.src;
    
    if (currentSrc !== newSrc && newSrc) {
      // 重置状态
      el.removeAttribute('data-lazy-loaded');
      loadImage(el, binding.value);
    }
  }
};

function loadImage(el, value) {
  // 获取图片地址
  const imgSrc = typeof value === 'string' ? value : (value?.src || el.src);
  
  if (!imgSrc) return;
  
  // 如果浏览器支持原生懒加载，使用原生懒加载（性能更好）
  if ('loading' in HTMLImageElement.prototype && el.tagName === 'IMG') {
    el.setAttribute('loading', 'lazy');
    el.src = imgSrc;
    return;
  }
  
  // 使用 Intersection Observer
  if ('IntersectionObserver' in window) {
    // 保存原始图片地址
    el.setAttribute('data-lazy-src', imgSrc);
    
    // 设置占位图或保持空白
    const placeholder = typeof value === 'object' && value.placeholder 
      ? value.placeholder 
      : 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
    
    if (el.tagName === 'IMG') {
      el.src = placeholder;
    }
    
    // 创建观察器
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const src = el.getAttribute('data-lazy-src');
          if (src && el.tagName === 'IMG') {
            // 创建新图片对象预加载
            const img = new Image();
            img.onload = () => {
              el.src = src;
              el.removeAttribute('data-lazy-src');
              el.setAttribute('data-lazy-loaded', 'true');
            };
            img.onerror = () => {
              el.removeAttribute('data-lazy-src');
            };
            img.src = src;
          }
          
          // 取消观察
          observer.unobserve(el);
        }
      });
    }, {
      // 提前 100px 开始加载
      rootMargin: '100px'
    });
    
    observer.observe(el);
  } else {
    // 不支持 Intersection Observer 的浏览器，直接加载
    if (el.tagName === 'IMG') {
      el.src = imgSrc;
    }
  }
}

